const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL as string,
  cognitoRegion: import.meta.env.VITE_COGNITO_REGION as string,
  superadminPoolId: import.meta.env.VITE_SUPERADMIN_POOL_ID as string,
  superadminClientId: import.meta.env.VITE_SUPERADMIN_CLIENT_ID as string,
  patientPoolId: import.meta.env.VITE_PATIENT_POOL_ID as string,
  patientClientId: import.meta.env.VITE_PATIENT_CLIENT_ID as string,
  devSlug: import.meta.env.VITE_DEV_SLUG as string | undefined,
  devShell: import.meta.env.VITE_DEV_SHELL as "admin" | "patient" | "tenant" | undefined,
  isDev: import.meta.env.DEV,
} as const;

export { env };
